import {RemoteGetHealthProviderLocationSupportAccredited} from 'data/usecases/private/booking-flow/health/remote-get-health-provider-location-support-accredited';
import {GetHealthProviderLocationSupportAccredited} from 'domain/usecases/private/booking-flow/health/get-health-provider-location-support-accredited';

import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthProviderLocationSupportAccredited =
	(): GetHealthProviderLocationSupportAccredited =>
		new RemoteGetHealthProviderLocationSupportAccredited(
			makeBFFApiUrl(BookingFlowEndPoints.healthProviderLocationSupportAccredited),
			makeAuthorizeHttpClientDecorator(),
		);
